import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap'
import * as Common from '../Common';

const A2formv1 = () => {
    const { paramType, paramId } = useParams();
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [rightA2FormFilled, setRightA2FormFilled] = useState([]);
    const [rightDownloads, setRightDownloads] = useState([]);

    const [requestType, setRequestType] = useState("");
    const [requestId, setRequestId] = useState("");

    const [reqData, setReqData] = useState([]);
    const [payListData, setPayListData] = useState([]);
    const [bankFileFinFrom, setBankFileFinFrom] = useState(0);
    const [bankFileFinTo, setBankFileFinTo] = useState(0);
    const [otherRemitData, setOtherRemitData] = useState([]);
    const [bankFileDate, setBankFileDate] = useState("");
    const [reqDate, setReqDate] = useState("");

    const Style1 = {
        fontSize: '12px',
        // fontWeight: 'bold',
        textAlign: 'center',
        fontStyle: 'italic',
    };

    const borderStyle = {
        border: '1px solid black',
        padding: '8px',
    }

    const highlight = {
        background: "yellow"
    }

    const boldStyle = {
        fontSize: '16px',
        fontWeight: 'bold'
    }

    const font16 = {
        fontSize: '16px',
    }

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            if (paramType === "F") {
                setRequestType("");
            } else {
                setRequestType(paramType);
                setRequestId(paramId)
            }
            Common.callApi(Common.apiRight, [sid, 'all', 'DOWNLOADS'], function (result) {
                let resp = JSON.parse(result);
                setRightDownloads(resp);
                if (resp.query === "1" && requestType === "F" && "1" === "2") {
                    Common.callApi(Common.apiRight, [sid, 'all', 'A2FORMFILLED'], function (result) {
                        let resp1 = JSON.parse(result);
                        setRightA2FormFilled(resp1);
                        if (resp1.query === "1") {
                            Common.callApi(Common.apiInProgress, [sid, 'detail', requestId], function (result1) {
                                let resp1 = JSON.parse(result1);
                                setReqData(resp1);
                                setPayListData(resp1.req_paymentdetail);
                                setBankFileDate(resp1.req_bankfiletrandate);
                                setReqDate(resp1.req_date);
                                if (resp1.req_bankfilemonth * 1 > 3) {
                                    setBankFileFinFrom(resp1.req_bankfileyear * 1);
                                    setBankFileFinTo(resp1.req_bankfileyear * 1 + 1);
                                } else {
                                    setBankFileFinTo(resp1.req_bankfileyear * 1);
                                    setBankFileFinFrom(resp1.req_bankfileyear * 1 - 1);
                                }
                            });
                            Common.callApi(Common.apiInProgress, [sid, 'otherremittance', requestId], function (result2) {
                                let resp2 = JSON.parse(result2);
                                setOtherRemitData(resp2);
                            });
                        }
                    });
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    return (
        <>
            <Container fluid>
                <Row>
                    <Col style={Style1}>
                        FORM A2 and Application cum Declaration for purchase of foreign exchange under Liberalized Remittance Scheme(LRS)
                        <br />for <b>INDIAN PASSPORT HOLDER</b><br /> 
                         (To be completed by the applicant in BLOCK letters)
                    </Col> 
                </Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>
                    {
                        requestType === "F" ? <>
                            <Col style={{ ...boldStyle, ...highlight }}>
                                Date: {(reqDate).split('-').reverse().join('/')}
                            </Col>
                        </> :
                            <>
                                <Col style={boldStyle}>
                                    Date:____________________________
                                </Col>
                            </>
                    }

                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        The Branch Manager
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    {
                        requestType === "F" ? <>
                            <Col style={{ ...boldStyle, ...highlight }} >
                                {reqData.req_brnnm}&nbsp;Branch
                            </Col>
                        </> : <>
                            <Col style={{ ...boldStyle }}>
                                ____________________________Branch
                            </Col>
                        </>
                    }
                </Row >
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        Dear Sir,
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        Subject: Remittance / Release of Foreign Exchange for Private Visit /Medical Treatment / Overseas Education 
                        /Remittance for family maintenance and savings - ADII Other purposes _OVERSEAS                                                                                          
                        (Please Specify) (Strike out whichever is not applicable) 
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        With reference to the above I request you to release foreign exchange for the purpose mentioned above and furnish the following details:
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        1. Details of Applicant/Remitter
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    {
                        requestType === "F" ? <>
                            <Col style={{ ...font16, ...highlight }}>
                                Applicant Name: {reqData.req_nameonpan} &nbsp;&nbsp;Date of Birth: __________________________<br />
                                <span style={{ fontSize: '12px', marginLeft: '220px' }}>(Should be as per PAN)</span>
                            </Col>
                        </> :
                            <>
                                <Col style={{ fontSize: '16px' }}>
                                    Applicant Name:_____________________________________________________Date of Birth: __________________________<br />
                                    <span style={{ fontSize: '12px', marginLeft: '220px' }}>(Should be as per PAN)</span>
                                </Col>
                            </>
                    }

                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    {
                        requestType === "F" ? <>
                            <Col style={{ ...font16, ...highlight }}>
                                Address:&nbsp; {reqData.req_remitteraddress}
                            </Col>
                        </> : <>
                            <Col style={{ fontSize: '16px' }}>
                                Address:________________________________________________________________________________________________________
                            </Col>
                        </>
                    }
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        _____________________________________________City: _________________________Pin Code:__________________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        State:________________________Telephone No.: __________________________Mobile No.: __________________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Email ID.:__________________________________________________ Nationality:    <span style={{ fontSize: '16px', fontWeight: 'bold', marginLeft: '40px' }}>INDIAN</span>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Residential Status:<span style={{ fontSize: '16px', fontWeight: 'bold', marginLeft: '65px' }}>RESIDENT</span> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; PAN No.: ______________________________________________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Passport No.: ________________________ Date of Expiry: ________________ Place of Issue: _______________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        2.  Details of Person on whose behalf remittance is being made only under mentioned above purpose.
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Student/Patient Name:_____________________________________________ Passport No.: __________________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        PAN No.: _______________________________ *College/University/Hospital:______________________________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Academic Year:______________________City/Country:_______________________ Date of Travel____________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        **Relationship with the Applicant/Remitter__________________________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px', fontWeight: 'bold', marginLeft: '70%' }}>
                        _____________________________<br />
                        Signature of the applicant
                    </Col>
                </Row>
                <Row>
                    {/* <Col style={{ fontSize: '11px', fontStyle: 'italic', fontWeight: 'bold' }}>
                        *copy of the letter from overseas university to be attached.<br />
                        ** Only Closed Relatives as per section VI of Companies act are permitted in the case of remittance which are related to each
                        other as Husband and wife, if they are members of HUF or they are related to each other as Father (including step Father),
                        Mother (including step Mother), Brother (including step Brother), Sister (including step Sister), Son (including step son), Son's
                        wife, Daughter (including step Daughter), Daughter's husband.
                    </Col> */}
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px', fontWeight: 'bold' }}>3. Foreign exchange amount to be released/ remitted (Please provide the exact split)</Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Cash Currency & Amount___________________________ Travellers Cheque Currency & Amount_________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Card Currency & Amount_____________________________ Draft Currency & Amount____________________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        TT Currency & Amount ______________________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Equivalent to Rs per unit FCN___________________________________Date__________________________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Total Rs Equivalent
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Country of  Travel/Remittance:____________________________________Date of Travel:____________________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Source of Funds:_________________________________________________________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        In case of Demand Draft
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Draft Favouring________________________________________________________________________________________________
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        In case of swift/Telegraphic transfer <br />
                        Beneficiary Details:
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Beneficiary Name_________________________________________________________________________________________________
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Beneficiary Address_______________________________________________________________________________________________
                    </Col>
                </Row>
                {/* <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Beneficiary Bank Account Number________________________________________________________________________________
                    </Col>
                </Row> */}
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Beneficiay Bank Name and Address_______________________________________________________________________________
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Swift Code / Routing No.__________________________________________________________________________________________
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        ABA Routing/BLZ/Sort Code / Bank Code:________________________________________________________________________
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Id IBAN International:______________________________________________________________________________________________
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Additional information to the beneficiay (if available)_____________________________________________________________
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Information to be sent with wire transfer, if any __________________________________________________________________
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Correspondent Bank Charges: Beneficiary / Ours <span style={{ fontWeight: 'bold' }}>(Strike out whichever is not applicable)</span>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px', fontWeight: 'bold' }}>
                        4. # Details of the Remittance made / transaction effected under the LRS in the current financial year.
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <span style={{ fontSize: '16px', fontWeight: 'bold' }}>(April_________March_________)</span><span style={{ fontSize: '18px' }}>
                         {/* (if needed attach additional sheets in the same format) */}
                         </span>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <table border="1" width="100%">
                            <tr>
                                <td style={borderStyle}>Sr.<br />No.</td>
                                <td style={borderStyle}>Date</td>
                                <td style={borderStyle}>FCN & <br />Amount</td>
                                <td style={borderStyle}>Equivalent to <br /> Rs.</td>
                                <td style={borderStyle}>Equivalent to <br /> USD</td>
                                <td style={borderStyle}>Name and address of AD branch/FFMC <br /> Through which the transaction has <br /> been effected</td>
                            </tr>
                            <tr>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                            </tr>
                            <tr>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                            </tr>
                            <tr>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                            </tr>
                            <tr>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                                <td style={borderStyle}></td>
                            </tr>
                        </table>
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: '18px', fontStyle: 'italic' }}>
                        # I, undertake that in case, if it is reported that I have been breached the LRS limit, I will be my responsibilty to bring back/surrender the amount purchase/remitted in excess of the LRS limit and thereafter I will approach RBI for compounding of contravention under FEMA 1999.
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '18px', fontWeight: 'bold', marginLeft: '70%' }}>
                        Signature of the applicant
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '18px', fontWeight: 'bold', textAlign: 'center' }}>
                        Declaration cum undertaking
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: '13px', fontStyle: 'italic' }}>
                        I, the undersigned, hereby declare that the total amount of foreign exchange purchased from or remitted through, all sources in india during the financial year as per item no. 4 of the Application, including the current transaction is within the overall limit of USD 250,000/-(USD Dollar Two Hundred and Fifty Thousand Only), which is the limit prescribed by the Reserve Bank of India for the said purpose. I certify that the source of funds for making the said remittance belongs to me and the foreign exchange shall not be used for prohibited purposes. The transaction details of which are mentioned above does not involve, and is not designed for the purpose of any contravention or evasion of the provisions of the FEMA, 1999 or of any Rule, Regulation, Notification, Direction or Order made there under. I also hereby agree and undertake to provide such information / documents as will reasonably 
                        satisfy you about this transaction in terms of this declartion. I shall be responsible and liable for any incorrect infomation provided by me. I agree that in the event the transaction is cancelled or revoked by me after submitting the request, any exchange losses incurred in tehis connection to be recovered from the refund amount. I further agree that once the funds remitted by me have been tranmitted by Zenith Leisure Holidays Limited (through AD Bank) to the conrrespondent and/or beneficiary banks, shall not be responsible for any delays in the disbursement of such funds including the withholding of such funds by the correspondent and/or Beneficiary bank because of incorrct information subitted by me, any charges levied by the beneficiary bank or exchange losses incurred in this connection, I  will be liable to pay the same to Zenith Leisure Holidays Limited. I further confirm that the foreign exchange released for above mentioned purpose will be used within 180 days of purchase. In case it is not possible to use the foreign exchange withing the period of 180 days, same will be surrendered to an authorized person. I am neither a politically Explosed Person (PEP), not related to any of the Pep's. I hereby give my consent for sharing details/documents/information provided by us regardsto this transaction with the AD I bank thru which remittance will processed and for the AD I bank to use, disclose, store and/or process such information, including for undertaking any verification, checks, authentication etc. Also to share the information with Regulator or any Law Enforcing Agencies wherever asked for as per extent Law/Rules/directions/Guidelines. In case of payment by cash I hereby declare that the aggregate value of foreign exchagne purchased by me, including this particular transaction, during the last 30 days, including the present date, either from Zenith Leisure Holidays Limited or from any other Authorized Dealers, by making payment in Cash does not exceed Rs. 50,000/-.
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '14px' }}>
                        I understand that it is mandatory for you to collect copy of my visa and ticket before release of foreign exchange and keep the same on record. In this case, the VISA will be i) stamped only after the endorsement of availing exchange ii) on arrival at the after my return from trip as a proof of obtaining visa as well as undertaking the trip aborad.
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {
                    requestType === "A" && requestId === "13" ?
                        <>
                            <Row>
                                <Col style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                    Payment for the above mentioned foreign exchange will be paid by M/s Avanse Financial Services Limited from my Overseas Education Loan A/c No._____________________________directly to Zenith Leisure Holidays Limited on my behalf.
                                </Col>
                            </Row>
                        </> : null
                }

                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
               <Row style={{paddingBottom:"24px"}}>
                
                    <Col md={6} style={{ fontSize: "18px", fontWeight: "bold",marginTop:"47px" }}>
                        <div>
                            ______________________________
                        </div>

                        <div style={{ marginTop: "7px" }}>
                            Signature of the applicant
                        </div>

                        <div>
                            Name:
                        </div>
                    </Col>

                  
                    <Col md={6} style={{ fontSize: "18px", fontWeight: "bold" }}>
                        <div>
                            ________________________________________________________________
                        </div>

                        <div style={{ marginTop: "12px" }}>
                            Signature of the natural guardian (if applicant is minor)
                        </div>

                        <div style={{marginTop: "18px"}}>
                            Name: &nbsp; _________________________________________________
                        </div>

                        <div>
                            Relationship with the Applicant: ________________________
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'center' }}>
                        <hr />Certificate by the Authorized Dealer
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        This is to certify that the remittance is not being made by/to ineligible entities and that the remittance is in conformity with the instructions issued by the Reserve Bank from time to time under the Scheme. I have verified KYC documents in original.
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col style={{ fontSize: '16px' }}>
                        Name and designation of the authorized official:
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>
                     <Col>
                        ______________<br />
                        &nbsp; Signature
                    </Col>
                    <Col>
                        _______________<br />
                        &nbsp; &nbsp; &nbsp; Date
                    </Col>
                    <Col>
                        ________________<br />
                        &nbsp; &nbsp; &nbsp; Place
                    </Col>
                    <Col>
                        ___________________<br />
                        &nbsp; &nbsp; Stamp & seal
                    </Col>
                </Row>
              
                <Row>&nbsp;</Row>
                <Row>
                   
                </Row>
                {/* <Row>&nbsp;</Row>
                <Row>&nbsp;</Row> */}
            </Container >
        </>
    )
}

export default A2formv1;
